import { isFunction } from 'lodash';
import { bool, func, node, string } from 'prop-types';
import { Component } from 'react';

import './form.scss';

class AuthForm extends Component<{
  id?: string;
  children?: React.ReactNode;
  action?: string;
  disabled?: boolean;
  withForm?: boolean;
  onSubmit?: Function;
}> {
  static propTypes = {
    id: string,
    children: node,
    action: string,
    disabled: bool,
    withForm: bool,
    onSubmit: func,
  };

  onSubmit = (event) => {
    event.preventDefault();
    const { disabled, onSubmit } = this.props;
    if (!disabled && isFunction(onSubmit)) {
      onSubmit();
    }
    return false;
  };

  render() {
    const { id, children, action, withForm } = this.props;
    if (withForm) {
      return (
        <form
          id={id}
          className="AuthForm alk-flex"
          action={action}
          onSubmit={this.onSubmit}
        >
          {children}
        </form>
      );
    }
    return (
      <div id={id} className="AuthForm alk-flex">
        {children}
      </div>
    );
  }
}

export default AuthForm;
